<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Inter Comm/Disc Factor Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{labels.productQuery}}</v-subheader>
              <div class="title">{{interCommDiscFactForm.product}}</div>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="interCommDiscFactForm.fact1">
                  <v-subheader class="queryLabel">{{labels.fact1}}</v-subheader>
                  <div class="title">{{interCommDiscFactForm.fact1}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactForm.fact2">
                  <v-subheader class="queryLabel">{{labels.fact2}}</v-subheader>
                  <div class="title">{{interCommDiscFactForm.fact2}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactForm.fact3">
                  <v-subheader class="queryLabel">{{labels.fact3}}</v-subheader>
                  <div class="title">{{interCommDiscFactForm.fact3}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="interCommDiscFactForm.fact4">
                  <v-subheader class="queryLabel">{{labels.fact4}}</v-subheader>
                  <div class="title">{{interCommDiscFactForm.fact4}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactForm.fact5">
                  <v-subheader class="queryLabel">{{labels.fact5}}</v-subheader>
                  <div class="title">{{interCommDiscFactForm.fact5}}</div>
                </v-flex>
                <v-flex xs4 v-if="interCommDiscFactForm.fact6">
                  <v-subheader class="queryLabel">{{labels.fact6}}</v-subheader>
                  <div class="title">{{interCommDiscFactForm.fact6}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <inter-comm-disc-rates v-if="!newInterCommDiscFact" :interCommDiscRates="interCommDiscRates" :interCommDiscFacts="factorForm"></inter-comm-disc-rates>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import InterCommDiscRates from './InterCommDiscRates'
import { ADMININTERMEDIARY_INTERCOMMDISCFACT } from '@/store/types'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        productType: 'Product Type*',
        product: 'Product*',
        productQuery: 'Product',
        effDate: 'Effective Date',
        endDate: 'End Date',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6'
      },
      interCommDiscFactForm: {
        inter: undefined,
        product: undefined,
        effDate: undefined,
        endDate: undefined,
        fact1: undefined,
        fact2: undefined,
        fact3: undefined,
        fact4: undefined,
        fact5: undefined,
        fact6: undefined,
        revision: undefined
      },
      appID: undefined,
      productLoading: false,
      productList: [],
      menu: [],
      newInterCommDiscFact: false,
      submitting: false,
      interCommDiscRates: []
    }
  },
  computed: {
    appIDList() {
      return this.$store.state.adminInter.intermediary.appIDList
    },
    factorList() {
      return this.$store.state.adminInter.intermediary.factorList
    },
    factorForm() {
      const result = {
        fact1: this.interCommDiscFactForm.fact1,
        fact2: this.interCommDiscFactForm.fact2,
        fact3: this.interCommDiscFactForm.fact3,
        fact4: this.interCommDiscFactForm.fact4,
        fact5: this.interCommDiscFactForm.fact5,
        fact6: this.interCommDiscFactForm.fact6
      }
      return result
    }
  },
  methods: {
    async doInit() {
      if (!this.newInterCommDiscFact) {
        this.interCommDiscFactForm.product = this.product
        this.interCommDiscFactForm.effDate = this.effDate
        // Review
        await this.queryInterCommDiscFact()
        this.queryInterCommDiscRates()
      }
    },
    async queryInterCommDiscFact() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscFactorGet
      if (apiURI) {
        try {
          const expand = {
            inter: this.inter,
            product: this.interCommDiscFactForm.product,
            effDate: formatDisplayDateTime2(this.interCommDiscFactForm.effDate)
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Inter Comm/Disc Factor init
            this.interCommDiscFactForm.inter = data.interCommDiscFact.inter
            this.interCommDiscFactForm.product = data.interCommDiscFact.product
            this.interCommDiscFactForm.effDate = data.interCommDiscFact.effDate
            this.interCommDiscFactForm.endDate = data.interCommDiscFact.endDate
            this.interCommDiscFactForm.fact1 = data.interCommDiscFact.fact1
            this.interCommDiscFactForm.fact2 = data.interCommDiscFact.fact2
            this.interCommDiscFactForm.fact3 = data.interCommDiscFact.fact3
            this.interCommDiscFactForm.fact4 = data.interCommDiscFact.fact4
            this.interCommDiscFactForm.fact5 = data.interCommDiscFact.fact5
            this.interCommDiscFactForm.fact6 = data.interCommDiscFact.fact6
            this.interCommDiscFactForm.revision = data.interCommDiscFact.revision

            const interCommDiscFactors = {
              fact1: this.interCommDiscFactForm.fact1,
              fact2: this.interCommDiscFactForm.fact2,
              fact3: this.interCommDiscFactForm.fact3,
              fact4: this.interCommDiscFactForm.fact4,
              fact5: this.interCommDiscFactForm.fact5,
              fact6: this.interCommDiscFactForm.fact6
            }
            this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT, interCommDiscFactors)
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async queryInterCommDiscRates() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscRates
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            inter: this.inter,
            product: this.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.interCommDiscRates = []
              data.map((interCommDiscRate) => {
                const convertInterCommDiscRate = {
                  inter: interCommDiscRate.inter,
                  product: interCommDiscRate.product,
                  effDate: this.formatDateTime2(interCommDiscRate.effDate),
                  endDate: this.formatDateTime2(interCommDiscRate.endDate),
                  commGN: interCommDiscRate.commGN,
                  commPct: interCommDiscRate.commPct,
                  discPct: interCommDiscRate.discPct,
                  fact1: interCommDiscRate.fact1,
                  fact2: interCommDiscRate.fact2,
                  fact3: interCommDiscRate.fact3,
                  fact4: this.formatDisplayNumber(interCommDiscRate.fact4),
                  fact5: this.formatDisplayNumber(interCommDiscRate.fact5),
                  fact6: this.formatDisplayNumber(interCommDiscRate.fact6),
                  protComm: this.formatBoolean(interCommDiscRate.protComm),
                  protDisc: this.formatBoolean(interCommDiscRate.protDisc),
                  revision: interCommDiscRate.revision
                }
                this.interCommDiscRates.push(convertInterCommDiscRate)
              })
            } else {
              this.interCommDiscRates = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  created() {
    this.doInit()
  },
  props: {
    inter: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    effDate: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    InterCommDiscRates
  }
}
</script>

<style lang="scss">

</style>
